<template>
  <div>
    <!-- <DarkModeSwitcher /> -->
    <MobileMenu />
    <div class="flex">
      <!-- BEGIN: Side Menu -->
      <nav class="side-nav">
        <!-- BEGIN: Logo -->
        <a :href="homepage" class="intro-x flex justify-center items-center">
          <span class="hidden xl:block text-white text-lg ml-3">
            <img class="w-16" src="@/assets/images/logo.png" />
          </span>
        </a>
        <!-- END: Logo -->
        <div class="my-6"></div>
        <ul>
          <!-- BEGIN: First Child -->
          <template v-for="(menu, menuKey) in formattedMenu">
            <li
              v-if="menu == 'devider'"
              :key="menuKey"
              class="side-nav__devider my-6"
            ></li>
            <li v-else :key="menuKey">
              <SideMenuTooltip
                tag="a"
                :content="menu.title"
                href="javascript:;"
                class="side-menu"
                :class="{
                  'side-menu--active': menu.active,
                  'side-menu--open': menu.activeDropdown
                }"
                @click.native="linkTo(menu)"
              >
                <div class="side-menu__icon">
                  <component :is="menu.icon" />
                </div>
                <div class="side-menu__title">
                  {{ menu.title }}
                  <ChevronDownIcon
                    v-if="$h.isset(menu.subMenu)"
                    class="side-menu__sub-icon"
                    :class="{ 'transform rotate-180': menu.activeDropdown }"
                  />
                </div>
              </SideMenuTooltip>
            </li>
          </template>
          <!-- END: First Child -->

          <!-- BEGIN: Filter Menu -->
          <template v-for="(filter, filterKey) in filterMenu">
            <!-- <li
              v-if="menu == 'devider'"
              :key="menuKey"
              class="side-nav__devider my-6"
            ></li> -->
            <li :key="'filter' + filterKey">
              <SideMenuTooltip
                tag="span"
                :content="filter.title"
                class="side-menu"
              >
                <div class="side-menu__icon">
                  <component :is="filter.icon" />
                </div>
                <div class="side-menu__title">
                  {{ filter.title }}
                </div>
              </SideMenuTooltip>
              <!-- BEGIN: Second Child -->
              <transition @enter="enter" @leave="leave">
                <tags-input
                  v-model="filter_params[filter.model]"
                  :elementId="filter.title"
                  :add-tags-on-comma="true"
                  :typeahead="true"
                  :typeahead-url="api_url + filter.endpoint"
                  :typeahead-show-on-focus="true"
                  :typeahead-activation-threshold="0"
                  :typeahead-max-results="0"
                  :only-existing-tags="true"
                  typeahead-style="dropdown"
                ></tags-input>
              </transition>
              <!-- END: Second Child -->
            </li>
          </template>
          <!-- END: Filter Menu  -->
        </ul>
        <button
          class="w-full bg-white my-8 p-4 rounded-lg text-transpurple mx-auto text-xl"
          @click="filterPortal"
        >
          FILTER
        </button>
      </nav>
      <!-- END: Side Menu -->
      <!-- BEGIN: Content -->
      <div class="content">
        <!-- <TopBar /> -->
        <router-view />
      </div>
      <!-- END: Content -->
    </div>
  </div>
</template>

<script>
import Velocity from "velocity-animate";
import MobileMenu from "@/components/MobileMenu";
import SideMenuTooltip from "@/components/SideMenuTooltip";
import VoerroTagsInput from "@voerro/vue-tagsinput";
import { createNamespacedHelpers } from "vuex";

const { mapActions } = createNamespacedHelpers("filtersMenu");

export default {
  components: {
    SideMenuTooltip,
    MobileMenu,
    "tags-input": VoerroTagsInput
  },
  data() {
    return {
      formattedMenu: [],
      filterMenu: this.$store.state.filtersMenu.filters,
      api_url: `${window.api}`,
      filter_params: {},
      url_params: {},
      host_url: `${window.host}`,
      homepage: `${window.homepage}`
    };
  },
  computed: {
    sideMenu() {
      return this.nestedMenu(this.$store.state.sideMenu.menu);
    }
  },
  watch: {
    $route() {
      this.formattedMenu = this.$h.assign(this.sideMenu);
    }
  },
  mounted() {
    cash("body")
      .removeClass("login")
      .addClass("app");
    this.formattedMenu = this.$h.assign(this.sideMenu);
  },
  methods: {
    // onTagAdded(slug) {
    //   console.log(`Tag added: ${JSON.stringify(slug)}`);
    // },
    ...mapActions(["changeSelectedFilters"]),
    filterPortal() {
      for (let filter in this.filter_params) {
        let arr = [];
        this.filter_params[filter].forEach(item => {
          arr.push(item["key"]);
        });
        this.url_params[filter] = arr;
      }
      // this.$store.dispatch(
      //   "filtersMenu/changeSelectedFilters",
      //   this.url_params
      // );
      this.changeSelectedFilters(this.url_params);
    },
    nestedMenu(menu) {
      menu.forEach((item, key) => {
        if (typeof item !== "string") {
          menu[key].active =
            (item.pageName == this.$route.name ||
              (this.$h.isset(item.subMenu) &&
                this.findActiveMenu(item.subMenu))) &&
            !item.ignore;
        }

        if (this.$h.isset(item.subMenu)) {
          menu[key].activeDropdown = this.findActiveMenu(item.subMenu);
          menu[key] = {
            ...item,
            ...this.nestedMenu(item.subMenu)
          };
        }
      });

      return menu;
    },
    findActiveMenu(subMenu) {
      let match = false;
      subMenu.forEach(item => {
        if (item.pageName == this.$route.name && !item.ignore) {
          match = true;
        } else if (!match && this.$h.isset(item.subMenu)) {
          match = this.findActiveMenu(item.subMenu);
        }
      });
      return match;
    },
    linkTo(menu) {
      if (this.$h.isset(menu.subMenu)) {
        menu.activeDropdown = !menu.activeDropdown;
      } else {
        this.$router.push({
          name: menu.pageName
        });
      }
    },
    enter(el, done) {
      Velocity(
        el,
        "slideDown",
        {
          duration: 300
        },
        {
          complete: done
        }
      );
    },
    leave(el, done) {
      Velocity(
        el,
        "slideUp",
        {
          duration: 300
        },
        {
          complete: done
        }
      );
    }
  }
};
</script>

<style lang="scss">
@import url("https://cdn.jsdelivr.net/npm/@voerro/vue-tagsinput@2.4.3/dist/style.css");
.side-nav span.side-menu {
  padding-left: 0;
  &:focus {
    outline: none !important;
  }
}
</style>
